// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	DualDropdown1AutoComplete: 'dual-dropdown-1-auto-complete',
	BrokerageItemDiv: 'brokerage-item-div',
	BrokerItemDiv: 'broker-item-div',
	CreateBrokerageButton: 'create-brokerage-button',
	NameBadge: 'name-badge',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
